import TutorialImage5 from "@/assets/images/tutorialImage5.png";
import { useTranslation } from "react-i18next";

function Page5() {
  const { t } = useTranslation("New");

  return (
    <div className="w-full flex flex-col gap-4 items-center">
      <div className="w-[500px] h-[250px]">
        <img src={TutorialImage5} alt="tutorial" />
      </div>

      <div className="flex flex-col gap-4 mt-13">
        <p className="font-medium text-center">{t("onboardingDesc5")}</p>
      </div>
    </div>
  );
}

export default Page5;
